/* eslint-disable react/prop-types, implicit-arrow-linebreak */
import React from "react";
import { Select } from "./SelectComponents";

const CountryFilter = ({
  selectedCountries,
  setSelectedCountries,
  options,
}) => {
  return (
    <Select
      valueFunction={(country) => ({
        label: I18n.t(`country.${country}`),
        value: country,
      })}
      selectedOptions={selectedCountries}
      setSelectedOptions={setSelectedCountries}
      options={options}
      placeholder={I18n.t("job_board_filters.generic.country")}
    />
  );
};

export default CountryFilter;
